<template>
  <div class="bg-white p-4 rounded-2xl shadow-md border space-y-4">
    <div class="flex justify-between items-center">
      <div>
        <h2 class="text-lg font-semibold">👤 {{ session.leadName }}</h2>
        <p class="text-sm text-gray-500">Session ID: {{ session.sessionId }}</p>
        <p class="text-sm text-gray-400">{{ formatDate(session.createdAt) }}</p>
      </div>
      <div>
        <span class="text-xs px-2 py-1 rounded bg-blue-100 text-blue-600">
          {{ session.status }}
        </span>
      </div>
    </div>
    <div>
      <p class="text-sm text-gray-700">
        {{ session.summary }}
      </p>
    </div>
    <div class="space-y-2">
      <p class="text-sm font-semibold">Conversation:</p>
      <div class="bg-gray-50 p-2 rounded text-sm max-h-40 overflow-y-auto space-y-1">
        <div v-for="(msg, i) in session.messages" :key="i">
          <span :class="msg.role === 'assistant' ? 'text-blue-600' : 'text-gray-800'">
            <strong>{{ msg.role }}:</strong>
          </span>
          <span>{{ msg.content || '(No content)' }}</span>
        </div>
      </div>
    </div>
    <div class="flex justify-between text-sm text-gray-500">
      <div>
        Tokens: {{ session.totalTokens }} | Cost: ${{ session.totalCost ? session.totalCost.toFixed(4) : '0.0000' }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SessionCard',
  props: {
    session: {
      type: Object,
      required: true
    }
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return '';
      return new Date(dateStr).toLocaleString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    }
  }
}
</script>
